import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Gauge, ArrowRight } from "lucide-react";

export default function Register() {
  const { register, error } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await register(name, email, password);
    setLoading(false);
    if (ok) navigate("/app");
  };

  return (
    <div className="bg-noise min-h-screen grid grid-cols-1 lg:grid-cols-2" style={{ background: "var(--avsl-bg)" }}>
      <div className="flex items-center justify-center px-6 py-16 relative z-10 order-2 lg:order-1">
        <div className="w-full max-w-md">
          <div className="overline mb-3">Nova Conta</div>
          <h2 className="font-display text-5xl leading-none">Cadastrar</h2>
          <p className="mt-3 text-neutral-400 text-sm">Crie sua conta gratuita.</p>

          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="register-form">
            <div>
              <label className="overline mb-2 block">Nome</label>
              <input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} required className="avsl-input" placeholder="Seu nome" />
            </div>
            <div>
              <label className="overline mb-2 block">E-mail</label>
              <input data-testid="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="avsl-input" placeholder="voce@empresa.com" />
            </div>
            <div>
              <label className="overline mb-2 block">Senha</label>
              <input data-testid="register-password" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required className="avsl-input" placeholder="Mínimo 6 caracteres" />
            </div>

            {error && (
              <div data-testid="register-error" className="border-l-2 pl-3 py-2 text-sm text-red-300" style={{ borderColor: "var(--avsl-red)" }}>
                {error}
              </div>
            )}

            <button data-testid="register-submit" type="submit" disabled={loading} className="avsl-btn w-full">
              {loading ? "Criando conta..." : (<>Criar Conta <ArrowRight size={16} strokeWidth={2.5} className="ml-2" /></>)}
            </button>
          </form>

          <div className="mt-8 text-sm text-neutral-500">
            Já tem conta?{" "}
            <Link to="/login" data-testid="link-login" className="text-white hover:text-red-400 underline underline-offset-4">
              Entrar
            </Link>
          </div>
        </div>
      </div>

      <div className="relative hidden lg:block overflow-hidden order-1 lg:order-2" style={{ background: "#050505" }}>
        <img
          src="https://images.pexels.com/photos/6169859/pexels-photo-6169859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(270deg, rgba(0,0,0,0.2) 0%, rgba(10,10,10,0.9) 100%)" }} />
        <div className="absolute top-8 right-8 flex items-center gap-3 z-10">
          <div>
            <div className="font-display text-2xl leading-none text-right">AVSL</div>
            <div className="overline mt-1 text-right">Rastreamento Veicular</div>
          </div>
          <div className="w-10 h-10 flex items-center justify-center" style={{ background: "var(--avsl-red)" }}>
            <Gauge size={22} strokeWidth={2.5} color="#fff" />
          </div>
        </div>
        <div className="absolute bottom-10 left-8 right-8 z-10 text-right">
          <div className="overline mb-3" style={{ color: "var(--avsl-red-soft)" }}>Cadastre-se agora</div>
          <h1 className="font-display text-6xl leading-[0.9]">
            Sua próxima<br /> <span style={{ color: "var(--avsl-red)" }}>campanha viral</span>
          </h1>
        </div>
        <div className="absolute top-0 left-0 h-full w-4 stripe-red opacity-40" />
      </div>
    </div>
  );
}
